import axios from 'axios';

const { post } = axios;

export default {
  getPresignedUrls: data => post('/v1/uploads/presigned-urls/', data),
  uploadFile: async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl, {
      method: 'PUT',
      headers: { 'Content-Type': contentType },
      credentials: 'omit',
      body: file,
    });

    if (!response.ok) {
      throw new Error(`Upload failed for ${file.name} (${response.status})`);
    }
  },
};
